const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/StartPage/styles.ts';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

export const logoFrameStyle = css`
    display: flex;
    align-items: center;
    flex-direction: row;
`;
export const frameStyle = css`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    background-color: ${theme.palette.background.default};
`;
export const logoFrameStyleVerticalCenter = css`
    margin: auto;
`;
export const frameStyleAbove = css`
    position: absolute;
    top: 0;
    left: 0;
`;

export const frameStyleLeft = css`
    flex-grow: 1;
    flex-shrink: 0;
    flex-grow: 5.5;
    flex-basis: auto;
`;

export const frameStyleRight = css`
    overflow-y: auto;
    flex-grow: 6.5;
    flex-shrink: 0;
    flex-basis: 600px;
`;

export const frameStyleBelow = css`
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    opacity: 0.9;
    position: absolute;
`;

export const btnRoot = css`
    width: ${theme.spacing(18)};
`;

export const welcomeMessage = css`
    max-width: ${theme.spacing(62)};
`;

export const contentWrapper = css`
    margin: ${theme.spacing(7, 7)};
    width: fit-content;
    align-items: start;
    display: flex;
    flex-direction: column;
`;

export const contentWrapperSmDevices = css`
    height: 100%;
    margin: ${theme.spacing(2, 2)};

    & :is(p, h1, h2, h3, h4, h5, h6, input, label) {
        text-align: start;
    }
`;

export const startPageStyleTitle = css`
    margin: 0;
    color: ${theme.palette.secondary.main};
`;
